import { ReactComponent as NextIcon } from '@ui-kit/icons/arrow-next.svg';
import { ReactComponent as PrevIcon } from '@ui-kit/icons/arrow-back.svg';
import styles from '../styles/skipBtn.module.scss'

function skipBtn(props: {
  prev: () => void,
  next: () => void
}) {

  return (
    <div className={styles.skip}>
      <button onClick={props.prev}>
        <PrevIcon />
      </button>
      <button onClick={props.next}>
        <NextIcon />
      </button>
    </div>
  )
}

export default skipBtn